import type { TodoItemFragment } from 'src/generated/graphql.js';
import type { TodoItem } from 'src/requests/todos.js';

export enum TodoView {
  FULL = 'full',
  DAYS = 'days',
  COLUMNS = 'columns',
}

export type SelectedDateItem = {
  start: string;
  end: string;
};

export enum SortOrder {
  ASCENDENT = 'asc',
  DESCENDENT = 'desc',
}

export enum SortType {
  TITLE = 'title',
  DUEDATE = 'dueDate',
  CREATIONDATE = 'createdAt',
  OWNER = 'owner',
  ASSIGNEE = 'assignee',
}

export type TodoRecurrenceCreateModalProps = {
  defaultTodoList: string;
  activeTodoGroup: string;
  selectedDate: SelectedDateItem;
  createTodo: any;
  updateTodo: any;
  selectedTodo: TodoItem | TodoItemFragment;
  isLoading: boolean;
};
